import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/appContext';
import TokenService from '../utils/TokenService';
import MainMenu from '../components/MainMenu';
import { classNames } from 'primereact/utils';
import { Avatar } from 'primereact/avatar';

const Logout = () => {
    const { logoutUser } = useAppContext();
    const [countdown, setCountdown] = useState(4);
    const [hasRedirectUrl, setHasRedirectUrl] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState(null);

    useEffect(() => {
        const firstFunction = async () => {
            await logoutUser();
        }
        const secondFunction = async () => {
            await firstFunction();
            var _redirectUrl = TokenService.getRedirectOnLogout();
            TokenService.removeRedirectOnLogout();
            if (!_redirectUrl) {
                _redirectUrl = process.env.REACT_APP_PUBLIC_SITE;
            }
            setRedirectUrl(_redirectUrl);
            setHasRedirectUrl(true);
            const timer = setInterval(() => {
                setCountdown((prevCount) => {
                    if (prevCount <= 1) {
                        clearInterval(timer);
                        window.location.href = _redirectUrl;
                    }
                    return prevCount - 1;
                });
            }, 1000);
        }
        secondFunction();
    }, []);

    const status = () => {
        return (
            <div>
                <h4>Logout Successful</h4>
                {hasRedirectUrl && (
                    <>
                        <div className='text-lg'>You will be redirected in {countdown} seconds to:</div>
                        <div className='mt-2'>
                            <a href={redirectUrl}>{redirectUrl}</a>
                        </div>
                        <div className="flex justify-content-center mt-2">
                            <Avatar label="or" shape="circle" />
                        </div>
                        <div className='flex flex-row mt-2 justify-content-center'>
                            <div className='flex mr-2'>
                                <a href={process.env.REACT_APP_NETWORK_SITE}>Home</a>
                            </div>
                            <div>
                                |
                            </div>
                            <div className='flex ml-2'>
                                <a href={process.env.REACT_APP_ID_SITE + "/login"}>Login</a>
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }

    const layoutContainerClassName = classNames(
        "layout-wrapper ",
        "pages-body",
        "login-page",
        "flex",
        "flex-column",
        "layout-menu-cyan layout-topbar-cyan",
        {
            "layout-topbar-mobile-active": false,
            "p-input-outlined": "outlined",
        }
    );

    return (
        <div className={layoutContainerClassName}>
            <MainMenu />
            <div className="align-self-center mt-auto mb-auto">
                <div className="pages-panel card flex flex-column p-4">
                    {status()}
                </div>
            </div>
        </div>
    );
};

export default Logout;
